import React from "react"

const Settings = () => {
    return (
        <h2>Настройки</h2>
    )
}

export default Settings